import Input from './form-input';
import Button from './button';

const Form = { Input, Button };
export default Form;
export { Input, Button };
